import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory, Route } from 'react-router';
import { IntlProvider } from 'react-intl';
import { FluxibleComponent } from 'fluxible-addons-react';
import Fluxible from 'fluxible';
import user from 'contest/apps/design-details/models/user';
import ddo from '@99designs/common/apps/ddo/index';

// Stores
import ActiveUserFlagStore from 'contest/stores/active-user-flag-store';
import ContestStore from 'contest/stores/contest-store';
import ContestsActiveUserStore from 'contest/stores/ContestsActiveUserStore';
import LanguageStore from 'contest/stores/language-store';
import OnboardingPromptStore from 'contest/stores/onboarding-prompt-store';
import OnlineStatusStore from 'contest/stores/online-status-store';

// Actions
import markAsSeen from 'contest/apps/design-details/actions/mark-as-seen';
import markAsRead from 'contest/apps/design-details/actions/mark-as-read';

// Models
import design from 'contest/apps/design-details/models/design';
import designCollection from 'contest/apps/design-details/models/design-collection';
import designComment from 'contest/apps/design-details/models/design-comment';
import designCommentCollection from 'contest/apps/design-details/models/design-comment-collection';

import renderDdo from './renderDdo';

document.addEventListener('DOMContentLoaded', function () {
    const appNode = document.getElementById('design-details-app');
    const appDataNode = document.getElementById('design-details-app-data');
    const { initData } = JSON.parse(appDataNode.textContent);
    const { intl, urls, contestState, siteLanguage, ownerUserId } = initData;
    const activeUser = window.activeUser ? user.create(user.fromJSON(window.activeUser)) : null;
    const ddoPath = '/:category/contests/:slug-:parentId/entries/:designId';
    const NoOpComponent = () => null;

    const fluxibleApp = new Fluxible({
        stores: [
            ActiveUserFlagStore,
            OnlineStatusStore,
            OnboardingPromptStore,
            ContestsActiveUserStore,
            ContestStore,
            LanguageStore,
        ],
    });

    const fluxibleContext = fluxibleApp.createContext();
    const models = {
        design,
        designCollection,
        designComment,
        designCommentCollection,
    };

    const { DdoComponent, setDesignCollection } = ddo({
        fluxibleApp,
        fluxibleContext,
        activeUser,
        isInline: true,
        models,
        goBack: () => {
            browserHistory.go(-1);
        },
        goTo: (path) => {
            browserHistory.replace(path);
        },
    });

    fluxibleContext.getStore(ActiveUserFlagStore).initFromActiveUser(activeUser);
    fluxibleContext.getStore(ContestStore).init(contestState);
    fluxibleContext.getStore(LanguageStore).init(siteLanguage);

    window.addEventListener('launchDesignView', (e) => {
        return setDesignCollection(designCollection.fromJSON(e.detail.designCollection)).then(() =>
            browserHistory.push(e.detail.path)
        );
    });

    window.addEventListener('ddoDidLoadDesign', (e) => {
        const design = e.detail.design;
        const user = activeUser;
        if (user) {
            if (design.permission.canMarkAsSeen && !design.isSeen) {
                markAsSeen(user, design);
            }
            if (design.permission.canViewComments) {
                markAsRead(user, design);
            }
        }
    });

    ReactDOM.render(
        <IntlProvider locale={document.documentElement.lang} messages={intl.messages}>
            <FluxibleComponent context={fluxibleContext.getComponentContext()}>
                <Router history={browserHistory}>
                    <Route
                        path={ddoPath}
                        component={(props) =>
                            renderDdo(
                                DdoComponent,
                                props.params.designId,
                                urls,
                                activeUser,
                                ownerUserId
                            )
                        }
                    />
                    <NoOpComponent path="*" />
                </Router>
            </FluxibleComponent>
        </IntlProvider>,
        appNode
    );
});



// WEBPACK FOOTER //
// ./src/web/js/contest/inline-ddo.jsx